module.exports = __webpack_public_path__ + "static/img/tiktok_r.171edfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tiktok_r.png
// module id = 9ZeX
// module chunks = 1